import { useQuery } from "react-query";
import { fetchMyUsageData } from "./api";

export function useMyUsage(options={}) {
    return useQuery(["MyUsageData"], () => fetchMyUsageData(), {
      staleTime: 0, 
      ...options
    })
  }